<template>
  <div class="player">
    <match-tabs :top1="3" :matchId="matchId" :sportType="match.sportType" v-if="!hasScreenshot"></match-tabs>
    <share-top :name="match.group || match.chineseName" :icon="filterImage(match.unionIcon || match.icon)"
      :type="roundTitle ? roundTitle + '榜' : '球员榜'" v-else></share-top>
    <div class="box" v-if="match.sportType === '足球'">
      <div class="left" v-if="!hasScreenshot">
        <div v-for="item, i in matchesType.footballs" :key="i" :class="{ 'player-select-true': item.id == listData.id }"
          @click="getInit(item.id, item.api)">{{ item.val }}</div>
      </div>
      <div class="right" :class="!hasScreenshot ? '' : 'active2'">
        <div v-if="listData.id === 'shooterList'">
          <div class="layout title" v-if="listData.shooterList.length">
            <div>{{ $t('match.playerList.text_4') }}</div>
            <div>{{ $t('match.playerList.text_5') }}</div>
            <div>{{ $t('match.playerList.text_6') }}</div>
          </div>
          <div class="layout bor-color" v-for="shooter in listData.shooterList" :key="shooter.id">
            <div class="top">
              <span :class="{ highlightList: shooter.top < 4 }">{{ shooter.top }}</span><span>.</span>
              <span> {{ shooter.playerName }}</span>
            </div>
            <div class="team-icon">
              <img :src="filterImage(shooter.team.badge, 25, 25)" />
              {{ shooter.team.teamAlias || shooter.team.name }}
            </div>
            <div>
              <span>{{ shooter.goalCount }}</span><span v-if="shooter.penaltyCount > 0">({{ shooter.penaltyCount
              }})</span>
            </div>
          </div>
          <div class="match-note none" v-if="!listData.shooterList.length">还没有相关赛事数据，组委会正在录入中</div>
          <div class="match-note" v-else>赛事数据统计由组委会提供</div>
        </div>
        <div v-if="listData.id === 'CardsData'">
          <div class="CardsData title" v-if="listData.CardsData.length">
            <div></div>
            <div></div>
            <div>{{ $t('match.playerList.text_7') }}</div>
            <div>{{ $t('match.playerList.text_8') }}</div>
          </div>
          <div v-for="group in listData.CardsData" :key="group.teamId">
            <div class="CardsData group bor-color">
              <div><img :src="filterImage(group.teamInfo.team.badge, 30, 30)"></div>
              <div>{{ group.teamInfo.team.teamAlias || group.teamInfo.team.name }}</div>
              <div>{{ group.teamInfo.redCount }}</div>
              <div>{{ group.teamInfo.yellowCount }}</div>
            </div>
            <div class="CardsData bor-color card-col" v-for="player in group.teamPlayers" :key="player.playerId">
              <div></div>
              <div>{{ player.playerName }}</div>
              <div>{{ player.redCardCount }}</div>
              <div>{{ player.yellowCount }}</div>
            </div>
          </div>
          <div class="match-note none" v-if="!listData.CardsData.length">还没有相关赛事数据，组委会正在录入中</div>
          <div class="match-note" v-else>赛事数据统计由组委会提供</div>
        </div>
        <div v-if="listData.id === 'assistList'">
          <div class="layout title" v-if="listData.assistList.length">
            <div>{{ $t('match.playerList.text_4') }}</div>
            <div>{{ $t('match.playerList.text_5') }}</div>
            <div>{{ $t('match.playerList.text_9') }}</div>
          </div>
          <div class="layout bor-color" v-for="assister in listData.assistList" :key="assister.id">
            <div class="top">
              <span :class="{ highlightList: assister.top < 4 }">{{ assister.top }}</span><span>.</span>
              <span> {{ assister.playerName }}</span>
            </div>
            <div class="team-icon">
              <img :src="filterImage(assister.team.badge, 25, 25)" />
              {{ assister.team.teamAlias || assister.team.name }}
            </div>
            <div>
              <span>{{ assister.assistCount }}</span><span v-if="assister.penaltyCount > 0">({{ assister.penaltyCount
              }})</span>
            </div>
          </div>
          <div class="match-note none" v-if="!listData.assistList.length">还没有相关赛事数据，组委会正在录入中</div>
          <div class="match-note" v-else>赛事数据统计由组委会提供</div>
        </div>
      </div>
    </div>
    <div class="box" v-if="match.sportType === '篮球'">
      <div class="left" v-if="!hasScreenshot">
        <div v-for="item, i in matchesType.basketball" :key="i" :class="{ 'player-select-true': item.id == listData.id }"
          @click="getInit(item.id, item.api)">{{ item.val }}</div>
      </div>
      <div class="right" :class="!hasScreenshot ? '' : 'active2'">
        <div v-if="listData.id === 'shooterList'">
          <div class="layout title" v-if="listData.shooterList.length">
            <div>{{ $t('match.playerList.text_4') }}</div>
            <div>{{ $t('match.playerList.text_5') }}</div>
            <div>{{ $t('match.playerList.text_10') }}</div>
            <div>{{ $t('match.playerList.text_11') }}</div>
          </div>
          <div class="layout bor-color" v-for="shooter in listData.shooterList" :key="shooter.id">
            <div class="top">
              <span :class="{ highlightList: shooter.top < 4 }">{{ shooter.top }}</span><span>.</span>
              <span> {{ shooter.playerName }}</span>
            </div>
            <div class="team-icon">
              <img :src="filterImage(shooter.team.badge, 25, 25)" />
              {{ shooter.team.teamAlias || shooter.team.name }}
            </div>
            <div>
              <span>{{ (shooter.avgCount * 1).toFixed(1) }}</span>
            </div>
            <div>{{ shooter.gameCount }}</div>
          </div>
          <div class="match-note none" v-if="!listData.shooterList.length">还没有相关赛事数据，组委会正在录入中</div>
          <div class="match-note" v-else>赛事数据统计由组委会提供</div>
        </div>
        <div v-if="listData.id === 'assistList'">
          <div class="layout title" v-if="listData.assistList.length">
            <div>{{ $t('match.playerList.text_4') }}</div>
            <div>{{ $t('match.playerList.text_5') }}</div>
            <div>{{ $t('match.playerList.text_3') }}</div>
          </div>
          <div class="layout bor-color" v-for="assister in listData.assistList" :key="assister.id">
            <div class="top">
              <span :class="{ highlightList: assister.top < 4 }">{{ assister.top }}</span><span>.</span>
              <span> {{ assister.playerName }}</span>
            </div>
            <div class="team-icon">
              <img :src="filterImage(assister.team.badge, 25, 25)" />
              {{ assister.team.teamAlias || assister.team.name }}
            </div>
            <div>
              <span>{{ assister.assistCount }}</span>
            </div>
          </div>
          <div class="match-note none" v-if="!listData.assistList.length">还没有相关赛事数据，组委会正在录入中</div>
          <div class="match-note" v-else>赛事数据统计由组委会提供</div>
        </div>
        <div v-if="listData.id === 'ReboundsTop'">
          <div class="layout title" v-if="listData.ReboundsTop.length">
            <div>{{ $t('match.playerList.text_4') }}</div>
            <div>{{ $t('match.playerList.text_5') }}</div>
            <div>{{ $t('match.playerList.text_12') }}</div>
          </div>
          <div class="layout bor-color" v-for="assister in listData.ReboundsTop" :key="assister.id">
            <div class="top">
              <span :class="{ highlightList: assister.top < 4 }">{{ assister.top }}</span><span>.</span>
              <span> {{ assister.playerName }}</span>
            </div>
            <div class="team-icon">
              <img :src="filterImage(assister.team.badge, 25, 25)" />
              {{ assister.team.teamAlias || assister.team.name }}
            </div>
            <div>
              <span>{{ assister.reboundCount }}</span>
            </div>
          </div>
          <div class="match-note none" v-if="!listData.ReboundsTop.length">还没有相关赛事数据，组委会正在录入中</div>
          <div class="match-note" v-else>赛事数据统计由组委会提供</div>
        </div>
        <div v-if="listData.id === 'Interception'">
          <div class="layout title" v-if="listData.Interception.length">
            <div>{{ $t('match.playerList.text_4') }}</div>
            <div>{{ $t('match.playerList.text_5') }}</div>
            <div>{{ $t('match.playerList.text_13') }}</div>
          </div>
          <div class="layout bor-color" v-for="assister in listData.Interception" :key="assister.id">
            <div class="top">
              <span :class="{ highlightList: assister.top < 4 }">{{ assister.top }}</span><span>.</span>
              <span> {{ assister.playerName }}</span>
            </div>
            <div class="team-icon">
              <img :src="filterImage(assister.team.badge, 25, 25)" />
              {{ assister.team.teamAlias || assister.team.name }}
            </div>
            <div>
              <span>{{ assister.stealCount }}</span>
            </div>
          </div>
          <div class="match-note none" v-if="!listData.ReboundsTop.length">还没有相关赛事数据，组委会正在录入中</div>
          <div class="match-note" v-else>赛事数据统计由组委会提供</div>
        </div>
        <div v-if="listData.id === 'CapsTop'">
          <div class="layout title" v-if="listData.CapsTop.length">
            <div>{{ $t('match.playerList.text_4') }}</div>
            <div>{{ $t('match.playerList.text_5') }}</div>
            <div>{{ $t('match.playerList.text_14') }}</div>
          </div>
          <div class="layout bor-color" v-for="assister in listData.CapsTop" :key="assister.id">
            <div class="top">
              <span :class="{ highlightList: assister.top < 4 }">{{ assister.top }}</span><span>.</span>
              <span> {{ assister.playerName }}</span>
            </div>
            <div class="team-icon">
              <img :src="filterImage(assister.team.badge, 25, 25)" />
              {{ assister.team.teamAlias || assister.team.name }}
            </div>
            <div>
              <span>{{ assister.blockCount }}</span>
            </div>
          </div>
          <div class="match-note none" v-if="!listData.ReboundsTop.length">还没有相关赛事数据，组委会正在录入中</div>
          <div class="match-note" v-else>赛事数据统计由组委会提供</div>
        </div>
      </div>
    </div>
    <div class="box" v-if="match.sportType === '橄榄球'">
      <div class="rugby" v-if="!hasScreenshot">
        <div v-for="item, i in matchesType.rugby" :key="i" class="item">
          <div :class="{ 'player-select-true': item.id == listData.id }" @click="getBMRugbyMatchPlayerStats(item.id)"
            v-if="(item.val != '拔旗' && item.val != '擒抱') || (item.val == '拔旗' && isShowBaqi) || (item.val == '擒抱' && isShowTackle)">
            {{ item.val }}<br />{{ item.english }}
          </div>
        </div>
      </div>
      <div class="right">
        <div>
          <div class="layout title">
            <div>球员</div>
            <div>球队</div>
            <div style="padding-left: 0;">{{ listData.id == 'passYds' || listData.id == 'recYds' || listData.id ==
              'rushYds' ? '码数' : '次数' }}</div>
          </div>
          <div class="layout bor-color" v-for="shooter in rugbyList" :key="shooter.id">
            <div class="top">
              <span :class="{ highlightList: shooter.stats.rank < 4 }">{{ shooter.stats.rank }}</span><span>.</span>
              <span> {{ shooter.playerName }}</span>
            </div>
            <div class="team-icon">
              <img :src="filterImage(shooter.team.badge, 25, 25)" />
              {{ shooter.team.teamAlias || shooter.team.name }}
            </div>
            <div>
              <span>{{ shooter.stats.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="match.sportType === '冰球'"></div>
    <div v-if="match.sportType === '飞盘'"></div>
    <div v-if="match.sportType === '羽毛球'"></div>
    <share-footer :matchId="matchId" v-if="hasScreenshot"></share-footer>
  </div>
</template>

<script>
import matchTabs from './components/MatchTabs'
import { QNImageUtil } from '@/utils'
import shareTop from './components/ShareTop.vue'
import shareFooter from './components/ShareFooter.vue'

import { getBMShooterScores, getBMAssisterScores, getBMStageGamesByBMMatchId, getRedOrYellowCardByBMMatchId, getBMRebounds, getBMSteals, getBMBlocks, getBMRugbyMatchPlayerStats, getBMMatchInfo1 } from '@/api/match'
export default {
  components: { matchTabs, shareTop, shareFooter },
  data() {
    return {
      matchId: null,
      matchesType: {
        footballs: [
          {
            val: this.$t('match.playerList.text_1'),
            id: 'shooterList',
            api: 'getBMShooterScores'
          },
          {
            val: this.$t('match.playerList.text_2'),
            id: 'CardsData',
            api: 'getRedOrYellowCardByBMMatchId'
          },
          {
            val: this.$t('match.playerList.text_3'),
            id: 'assistList',
            api: 'getBMAssisterScores'
          }
        ],
        basketball: [
          {
            val: this.$t('match.playerList.text_15'),
            id: 'shooterList',
            api: 'getBMShooterScores'
          },
          {
            val: this.$t('match.playerList.text_16'),
            id: 'assistList',
            api: 'getBMAssisterScores'
          },
          {
            val: this.$t('match.playerList.text_12'),
            id: 'ReboundsTop',
            api: 'getBMRebounds'
          },
          {
            val: this.$t('match.playerList.text_13'),
            id: 'Interception',
            api: 'getBMSteals'
          },
          {
            val: this.$t('match.playerList.text_14'),
            id: 'CapsTop',
            api: 'getBMBlocks'
          }
        ],
        hockey: [
          {
            val: '射手榜',
            id: 'shooterList',
            api: 'GetBMShooterScores'
          }
        ],
        rugby: [
          {
            val: '传球达阵 PaTD',
            id: 'passTd',
            api: 'GetBMRugbyMatchPlayerStats'
          },
          {
            val: '接球达阵 RecTD',
            id: 'recTd',
            api: 'GetBMRugbyMatchPlayerStats'
          },
          {
            val: '跑球达阵 RshTD',
            id: 'rushTd',
            api: 'GetBMRugbyMatchPlayerStats'
          },
          {
            val: '传球码数 PaYds',
            id: 'passYds',
            api: 'GetBMRugbyMatchPlayerStats'
          },
          {
            val: '接球码数 RecYds',
            id: 'recYds',
            api: 'GetBMRugbyMatchPlayerStats'
          },
          {
            val: '跑球码数 RshYds',
            id: 'rushYds',
            api: 'GetBMRugbyMatchPlayerStats'
          },
          {
            val: '抄截',
            english: 'Int',
            id: 'int',
            api: 'GetBMRugbyMatchPlayerStats'
          },
          {
            val: '拔旗',
            english: 'Flag Pull',
            id: 'flagPull',
            api: 'GetBMRugbyMatchPlayerStats'
          },
          // 擒抱和拔旗 同api不同名而已
          {
            val: '擒抱',
            english: 'Tackle',
            id: 'flagPull',
            api: 'GetBMRugbyMatchPlayerStats'
          },
          {
            val: '擒杀',
            english: 'Sack',
            id: 'sack',
            api: 'GetBMRugbyMatchPlayerStats'
          }
        ],
      },
      match: {},
      type: 'shooterList',
      listData: {
        id: ''
      },
      isShowBaqi: false,
      isShowTackle: false,
      rugbyList: [],
      hasScreenshot: false,
      obj: {}
    }
  },
  created() {
    this.matchId = this.$route.query.matchId
    this.type = this.$route.query.type
    this.hasScreenshot = this.$route.query.hasScreenshot || false
  },
  computed: {
    roundTitle() {
      let list = []
      if (this.match.sportType === '篮球') list = this.matchesType.basketball
      if (this.match.sportType === '足球') list = this.matchesType.footballs
      if (this.match.sportType === '篮球') list = this.matchesType.rugby
      const obj = list.find(item => item.id == this.listData.id)
      return obj?.val || ''
    }
  },
  mounted() {
    // this.getInit('shooterList', 'getBMShooterScores')
    this.getBMMatchInfo1()
    this.getBMStageGamesByBMMatchId()
  },
  methods: {
    getBMStageGamesByBMMatchId() {
      const obj = {
        matchId: this.matchId,
      }
      getBMStageGamesByBMMatchId(obj).then(res => {
        const data = res.data
        this.obj = data.match
        const unionMatch = res.data.unionMatch
        document.title = data.match.chineseName.split('_')[1] + '-球员榜'
        const shareObj = {
          title: this.obj.chineseName.split('_')[0] + this.getPromotion(unionMatch.beginDate, unionMatch.endDate),
          abstract: this.obj.chineseName.split('_')[1] + '/球员榜',
          image: QNImageUtil.imageView(this.obj.icon)
        }
        this.wxShare(shareObj)
        let list = []
        if (this.obj.sportType === '篮球') list = this.matchesType.basketball
        if (this.obj.sportType === '足球') list = this.matchesType.footballs
        if (this.obj.sportType === '橄榄球') list = this.matchesType.rugby
        const obj = list.find(item => item.id == this.type)
        if (this.obj.sportType === '橄榄球') {
          this.type = this.type || 'passTd'
          this.getBMRugbyMatchPlayerStats(this.type)
          const obj = {
            matchId: this.matchId,
            bmMatchId: this.matchId,
            pageSize: 500
          }
          getBMShooterScores(obj).then(res => {
            const data = res.data
            this.match = data.match
          })
          return
        }
        if (obj) {
          this.getInit(obj.id, obj.api)
        } else {
          this.getInit('shooterList', 'getBMShooterScores')
        }
      })
    },
    getPromotion(createDate, endDate) {
      const startTime = new Date(createDate)
      const endTime = new Date(endDate)
      const currentTime = new Date()
      if (currentTime < startTime) {
        return '-敬请期待';
      } else if (currentTime >= startTime && currentTime <= endTime) {
        return '-激战正酣';
      } else {
        return '-完美闭幕';
      }
    },
    getInit(id, api) {
      this.type = id
      const Api = { getBMShooterScores, getBMAssisterScores, getRedOrYellowCardByBMMatchId, getBMRebounds, getBMSteals, getBMBlocks }
      const obj = {
        matchId: this.matchId,
        bmMatchId: this.matchId,
        pageSize: 500
      }
      Api[api](obj).then(res => {
        const data = res.data
        this.match = data.match
        this.listData[id] = this.handleTopThree(data.players)
        this.listData.id = id
        if (id === 'shooterList') { // 射手榜 得分棒
          var shooterScores = data.shooterScores || []
          this.listData[id] = this.handleTopThree(shooterScores, 'shooterList')
          this.listData.id = id
        }
        if (id === 'CardsData') { // 红黄牌
          var teams = data.teams
          var players = data.players
          this.listData[id] = this.groupTeamsInfo(teams, players)
          this.listData.id = id
        }
        if (id === 'assistList') {
          this.listData[id] = this.handleTopThree(data.assisterScores, 'assistList')
          this.listData.id = id
        }

        if (this.match.sportType === '橄榄球') {
          this.getBMRugbyMatchPlayerStats('passTd')
        }
      })
    },
    groupTeamsInfo(teams, players) {
      var groups = []
      var teamIds = []
      var teamsMapping = {}
      var playersGroupedByTeamId = {}
      var teamId = ''
      for (var i = 0; i < teams.length; i++) {
        var team = teams[i]
        teamId = team.teamId
        if (!teamsMapping[teamId]) {
          teamIds.push(teamId)
        }
        teamsMapping[teamId] = team
      }
      for (var j = 0; j < players.length; j++) {
        var player = players[j]
        teamId = player.teamId
        if (playersGroupedByTeamId[teamId]) {
          playersGroupedByTeamId[teamId].push(player)
        } else {
          playersGroupedByTeamId[teamId] = [player]
        }
      }
      for (var k = 0; k < teamIds.length; k++) {
        teamId = teamIds[k]
        var teamInfo = teamsMapping[teamId]
        var teamPlayers = playersGroupedByTeamId[teamId]
        var group = { teamInfo: teamInfo, teamPlayers: teamPlayers }
        groups.push(group)
      }
      return groups
    },
    handleTopThree(shooterScores, type) {
      if (!shooterScores || shooterScores.length < 1) {
        return shooterScores
      }
      var topNumber = 1
      shooterScores[0].top = topNumber
      var topArray = [shooterScores[0]]
      for (var i = 1; i < shooterScores.length; i++) {
        var index = topArray.length - 1
        if (this.match.sportType === '足球') {
          if (type === 'shooterList') {
            if (topArray[index].goalCount !== shooterScores[i].goalCount) {
              topNumber = i + 1
            }
          } else if (type === 'assistList') {
            if (topArray[index].assistCount !== shooterScores[i].assistCount) {
              topNumber = i + 1
            }
          }
        } else if (this.match.sportType === '篮球') {
          if (topArray[index].avgCount !== shooterScores[i].avgCount) {
            topNumber = i + 1
          } else if (topArray[index].assistCount !== shooterScores[i].assistCount) {
            topNumber = i + 1
          } else if (topArray[index].reboundCount !== shooterScores[i].reboundCount) {
            topNumber = i + 1
          } else if (topArray[index].stealCount !== shooterScores[i].stealCount) {
            topNumber = i + 1
          } else if (topArray[index].blockCount !== shooterScores[i].blockCount) {
            topNumber = i + 1
          }
        }
        shooterScores[i].top = topNumber
        topArray.push(shooterScores[i])
      }
      return topArray
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    getBMRugbyMatchPlayerStats(id) {
      this.listData.id = id
      const obj = {
        matchId: this.matchId,
        pageSize: 500,
        index: id,
      }
      getBMRugbyMatchPlayerStats(obj).then(res => {
        const data = res.data
        this.rugbyList = data.playerStatsList
        console.log(this.rugbyList);
      })
    },
    getBMMatchInfo1() {
      getBMMatchInfo1({ matchId: this.matchId, pageSize: 1000 }).then(data => {
        var gameType = data.match && data.match.gameType
        this.isShowBaqi = gameType && gameType.indexOf('腰旗') > -1
        this.isShowTackle = gameType && gameType.indexOf('装备') > -1
      })
    }
  }
}
</script>

<style scoped lang="scss">
.player {
  height: calc(100vh - 41px);

  .box {
    display: flex;
    width: 100%;
    height: auto;

    .left {
      width: 50px;
      min-width: 50px;
      height: auto;
      background-color: rgb(228, 228, 228);

      div {
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-size: 14px;
        color: rgb(157, 154, 153);
        font-weight: 500;
      }

      .player-select-true {
        color: #fff;
        background-color: #999;
      }
    }

    .rugby {
      height: auto;
      background-color: rgb(228, 228, 228);
      width: 70px;

      .item {
        div {
          height: 66px;
          padding: 13px 0;
          box-sizing: border-box;
          text-align: center;
          font-weight: 500;
          font-size: 14px;
          color: rgb(157, 154, 153);
          line-height: 20px;
        }

        .player-select-true {
          color: #fff;
          background-color: #999;
        }
      }
    }

    .right {
      flex: 1;
      height: 100%;
      max-width: calc(100% - 50px);
      overflow: hidden;
      overflow-y: auto !important;

      &::-webkit-scrollbar {
        display: none;
      }

      .layout {
        display: flex;

        div {
          height: 45px;
          line-height: 45px;
          padding: 0 10px;
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .top {
          padding-left: 10px !important;

          .highlightList {
            font-size: 18px;
            color: #419fb6;
            font-style: inherit;
            font-weight: 700;
          }
        }

        .team-icon {
          img {
            width: 24px;
            height: 24px;
            margin-right: 5px;
            vertical-align: middle;
          }
        }

        & div:nth-child(1) {
          flex: 0.8;
          padding-left: 15px;
        }

        & div:nth-child(2) {
          flex: 1.2;
          padding-left: 15px;
        }

        & div:nth-child(3) {
          flex: 0.5;
          text-align: center;
        }

        & div:nth-child(4) {
          flex: 0.4;
          text-align: center;
        }
      }

      .CardsData {
        display: flex;

        div {
          height: 45px;
          line-height: 45px;
          padding: 0 10px;
          font-size: 14px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        & div:nth-child(1) {
          flex: 1.5;
          padding-left: 10px;
          padding-right: 0;
        }

        & div:nth-child(2) {
          flex: 4.5;
          padding-left: 0px;
        }

        & div:nth-child(3) {
          flex: 3;
          text-align: center;
        }

        & div:nth-child(4) {
          flex: 1.5;
          text-align: center;
        }
      }

      .card-col {
        div {
          color: #ababab;
        }
      }

      .group {
        img {
          width: 30px;
          height: 30px;
          vertical-align: middle;
          border-radius: 4px;
        }
      }

      .match-note {
        font-size: 13px;
        color: #b5b5b5;
        padding: 10px 0;
        text-align: center;
        background-color: #F2F2F2;
      }

      .none {
        margin-top: -41px;
        padding: 100px 0;
        min-height: 100vh;
        box-sizing: border-box;
      }

      .bor-color {
        border-bottom: 1px solid rgb(228, 228, 228);
      }

      .title {
        background-color: rgb(242, 242, 242);
        color: rgb(170, 170, 170);
        font-weight: 500;
      }
    }

    .active2 {
      max-width: 100% !important;
    }
  }
}
</style>
